<template>
    <div class="preAlert">
        
        <div class="box-white-wrapper searchInventory">
            
            <div class="form">
                <form name="form" @submit.prevent="searchPackage">
                    <div :class="['form-input',{'has-error': $v.search.tracking.$error }]">
                        <vs-input label="Número de tracking" v-model.trim="$v.search.tracking.$model"/>
                        <span class="error-text" v-if="$v.search.tracking.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                    
                    <div class="form-input">
                        <vs-button color="primary" type="border" icon="" id="btnPaid2" class="vs-con-loading__container btnSEarch" :disabled="search.tracking != '' ? false : true" 
                                @click="searchPackage">Buscar</vs-button>
                    </div>
                </form>
                <vs-alert title="Tracking no encontrado" color="primary" active="true" v-if="notFound">
                    El tracking ingresado no fue encontrado</vs-alert>
            </div>
        </div>   

        <div class="box-white-wrapper">
            
            <div class="form">
                
                <div class="group">
                    <div class="form-input">
                        <vs-input label="Número de tracking" v-model.trim="inventory.tracking"/>
                        <!-- <span class="error-text" v-if="$v.inventory.tracking.$error"><feather type="info" />Este campo es requerido</span> -->
                    </div>
                    
                    <div :class="['form-input',{'has-error': $v.inventory.customer.$error }]">
                        <label for="">Cliente:</label>
                        <select-input :options="customers" v-model="$v.inventory.customer.$model"></select-input>
                        <span class="error-text" v-if="$v.inventory.customer.$error"><feather type="info" />Este campo es requerido</span>
                    </div>

                </div>
                <div class="group">
                    <div :class="['form-input',{'has-error': $v.inventory.product.$error }]">
                        <label class="vs-input--label">Producto <small class="needPermission" v-if="inventory.product.permission == 1">(requiere permiso)</small></label>
                        <select-input :options="products" v-model="$v.inventory.product.$model"></select-input>
                        <span class="error-text" v-if="$v.inventory.product.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                    <div :class="['form-input',{'has-error': $v.inventory.weight.$error }]">
                        <vs-input label="Peso (lb)" v-model.trim="$v.inventory.weight.$model" @keypress="isNumber($event)"/>
                        <span class="error-text" v-if="$v.inventory.weight.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                </div>
                <div class="group">
                    
                    <div :class="['form-input',{'has-error': $v.inventory.inv02Code.$error }]">

                        <vs-select autocomplete label="Ubicación:" v-model="$v.inventory.inv02Code.$model">
                            <vs-select-item :key="index" :value="item.code" :text="item.code" v-for="(item,index) in locations" />
                        </vs-select>

                        <span class="error-text" v-if="$v.inventory.inv02Code.$error"><feather type="info" />Este campo es requerido</span>
                    </div>

                    <div :class="['form-input']">
                        <vs-input label="Proveedor" v-model.trim="inventory.provider"/>
                        <!-- <span class="error-text" v-if="!inventory.price.required && inventory.price.$error"><feather type="info" />Este campo es requerido</span>
                        <span class="error-text" v-if="!inventory.price.minValue && inventory.price.required"><feather type="info" />El valor debe ser numérico</span> -->
                    </div>
                    <!-- <div :class="['form-input']">
                        <vs-input label="Precio (USD)" v-model.trim="inventory.price" @keypress="isNumber($event)"/> -->
                        <!-- <span class="error-text" v-if="!$v.inventory.price.required && $v.inventory.price.$error"><feather type="info" />Este campo es requerido</span>
                        <span class="error-text" v-if="!$v.inventory.price.minValue && $v.inventory.price.required"><feather type="info" />El valor debe ser numérico</span> -->
                    <!-- </div> -->
                </div>
                <div :class="['form-input']">
                    <vs-input label="Comentarios" v-model.trim="inventory.comments"/>
                    <!-- <span class="error-text" v-if="!$v.inventory.price.required && $v.inventory.price.$error"><feather type="info" />Este campo es requerido</span>
                    <span class="error-text" v-if="!$v.inventory.price.minValue && $v.inventory.price.required"><feather type="info" />El valor debe ser numérico</span> -->
                </div>

                <div class="form-input">
                    <vs-button color="primary" type="border" icon="" id="btnPaid" class="vs-con-loading__container" :disabled="disabled" 
                            @click="addPackage">Registrar</vs-button>
                </div>
                
                
            </div>


        </div>       
        <vs-popup class="media-wrapper" fullscreen title="Factura de compra" :active.sync="popupActivo4">
            <vs-tabs>
                <vs-tab label="Galería">
                    <div class="media-content">
                        <div :class="['gallery', { w100: resourceSelected === 0}]">
                            <div class="wrrapper">
                                <template v-for="(image, index) in resources">
                                    <div :key="`s-${index}`" :class="['sigle-image', {active: resourceSelected.id === image.id}]">
                                      <img :src="checkExtension(image.url)" alt="" @click="findResource(image.id, index)">
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="gallery-sidebar" v-if="resourceSelected !== 0">
                            <div class="detail">
                                <div class="title">Factura</div>
                                <div class="feature">
                                    <a :href="resourceSelected.url" target="_blank">
                                        <img :src="checkExtension(resourceSelected.url)"/>
                                    </a>
                                </div>
                                <div class="actions">
                                    <vs-button color="success" type="border" icon="check" @click="closeModalResource">Seleccionar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                
                <vs-tab label="Subir Factura">
                    <div class="dropzone-wrapper">
                        <vue-dropzone :options="dropzoneOpts" id="upload-images"
                            v-on:vdropzone-success="successUploaded" v-on:vdropzone-sending="sendingBeforeDropzone"> </vue-dropzone>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vs-popup>
    </div>
</template>
<script>
//local registration
import { mapState } from 'vuex'
import {helper} from '@/helpers/utils'
import vueDropzone from 'vue2-dropzone'
import { Role } from '@/helpers/Role.js'
import Http  from '@/helpers/Http.js'
// import VCreditCard from 'v-credit-card'
import 'v-credit-card/dist/VCreditCard.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import InventoryModel from "@/models/InventoryModel"
import { required } from 'vuelidate/lib/validators' 
import TaxDataService from "@/services/TaxDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import InventoryService from "@/services/InventoryService"
import ClientDataService from "@/services/ClientDataService"

export default {
  name: "PreAlertPacakge",
  mixins: [helper],
  components:{
    SelectInput,
    // VCreditCard,
    vueDropzone
  },
  data () {
    return {
        popupActivo4:false,
        resourceSelected: 0,
        confirmStatus: false,  
        units: [
            {
                code: 'lb',
                name: 'Libras'
            }
        ],
        Roles: [],
        resources:[],
        products: [],
        disabled: false,
        inventory: new InventoryModel(),
        locations: [],
        customers: [],
        notFound: false,
        search: { tracking: ""}
    }
  },
  validations: {
    inventory: {
        // customerName: { required },
        customer: { required },
        inv02Code: { required },
		// comments:     { required },
        // tracking:     { required },
		// phone:        { required },
		weight:       { required },
		// photo:        { required },
		product:      { required }, 
    },
    search: {
        tracking:     { required },
    }
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted () {
    this.getLocations();
    this.retrieveCustomers();
    this.retrieveTaxes();
    if(this.$route.params.id !== undefined){
        this.inventory.tracking = this.$route.params.id
    }
  },
  created(){
    this.Roles = Role
    if(this.Roles.Distribuitor === this.userInfoData.role){
        this.$router.push({ name: "packages"})
        this.$vs.notify({title:'Información!',text:'Acceso denegado!',color:'danger',icon:'error_outline'})
    }

  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
    dropzoneOpts() {
       return {
            url: Http.defaultApi + '/files/upload',
            thumbnailWidth: 150,
            maxFilesize: 5,
            method: "POST",
            withCredentials: false,
            acceptedFiles: ".jpg,.jpeg,.png,.gif,.mp4, .pdf",
            headers: { 
            'Access-Control-Allow-Origin': '*',
            'authorization':  this.userInfoData.boxkey,
            'x-access-token': this.userInfoData.boxkey
            }
       };
    }
  },
  methods:{  
    searchPackage(){
        this.notFound = false
        this.$v.search.$touch()
        if (this.$v.search.$invalid) return;
        const that = this
        that.loadingProgress ('#btnPaid2', '#1a426d')
        that.disabled = true
        InventoryService.searchByTracking(that.search)
        .then(response => {
            that.disabled = false
            console.log(response)
        
            this.inventory.tracking = response.data.obj.tracking
            this.inventory.weight   = response.data.obj.weight
            this.inventory.customer = { id: response.data.obj.customer.id, name: response.data.obj.customer.firstName +" "+ response.data.obj.customer.lastName }
            this.inventory.product = response.data.obj.product
            this.search = { tracking: "" }
            this.$v.search.$reset();
            that.$vs.loading.close('#btnPaid2 .con-vs-loading')
            // that.$vs.notify({title:'Información!',text:'El paquete fue encontrado exitosamente!',color:'success',icon:'check'})
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.disabled = false
            // this.notFound = true
            this.inventory.tracking = this.search.tracking
           
           that.$vs.notify({title:'Información!',text:'Paquete no encontrado',color:'danger',icon:'error_outline'})                
        });
           
    },
    successUploaded (file, response) {
        console.log('File', file);
        if(response.url !== ''){
            this.resources.push(response.obj)
            this.pack.resource = response.url+"?v="+this.getRandomNumber();
            this.popupActivo4 = false
        }
    },
    sendingBeforeDropzone (file, xhr, formData) {
        console.log('DEBUG: formData BEFORE ' + formData)
        formData.append('fileName', this.pack.tracking);
        formData.append('type', 'Invoice');
        formData.append('customer', this.assignTo == true ? this.customer.id : null);
    },
    retrieveTaxes() {
        TaxDataService.getAll()
        .then(response => {
            this.products = response.data;
            this.$Progress.finish()
        })
        .catch(e => {
            console.log(e);
            this.$Progress.finish()
            this.$vs.notify({title:'Error!',text:'Error obteniendo los productos',color:'danger',icon:'error_outline'})
        });
    },
    getLocations() {
        InventoryService.getLocations()
        .then(response => {
            this.locations =  response.data.records
        })
        .catch(e => {
            console.log(e);
            this.$vs.notify({title:'Error!',text:'Error obteniendo las ubicaciones',color:'danger',icon:'error_outline'})
        });
    },
    retrieveCustomers() {
        ClientDataService.getAll()
        .then(response => {
            response.data.forEach(element => {
                this.customers.push({
                    id: element.id, 
                    name: element.fullName,
                    email: element.email,
                    customerType: element.typecode
                })
            });
            // this.customer = this.customers[0]
            this.customers.push({id: 0, name: "SIN DEFINIR"})

        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los clientes!',color:'danger',icon:'error_outline'})
        });
    },
    addPackage(){
        this.$v.inventory.$touch()
        if (this.$v.inventory.$invalid) return;
        const that = this
        that.loadingProgress ('#btnPaid', '#1a426d')
        that.disabled = true
        this.inventory.customerfound = this.inventory.customer.id == 0 ? 0 : 1
        InventoryService.create(that.inventory)
        .then(response => {
            that.disabled = false
            console.log(response)
            this.inventory = new InventoryModel();
            this.$v.inventory.$reset();
            that.$vs.loading.close('#btnPaid .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'El paquete fue registrado exitosamente!',color:'success',icon:'check'})
            
            this.$router.push({ name: "InventoryDetail", params:{ id: response.data.obj.id }})
            
        })
        .catch((e) => {
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.disabled = false
            that.$vs.notify({title:'Información!',text: e.response.data.message,color:'danger',icon:'error_outline'})                
        });
           
    },
    closeModalResource () {
       this.pack.resource = this.resourceSelected.url+"?v="+this.getRandomNumber();
        this.popupActivo4 = false
    },
    findResource(_id){
      let found = this.resources.filter((item) => {
        return  _id === item.id
      })
      if( found.length > 0) {
        this.resourceSelected = found[0]
      }
    },
    removeResource(){
       this.pack.resource = ""
    },
    checkExtension(_url){
        if(this.isPdf(_url)){
           return require('@/assets/images/pdf_icon.png')
        }else{
           return _url
        }
    }
  }
}
</script>
